<div class="container" style="margin-top: 100px;"> 
    <div class="row mt-30 ">
        <div class="col-md-6 col-6">
          <img src="./assets/annual-breadcrumb.svg" class="logoicon">
        </div>
        <div class="col-md-6 col-12 bread-p text-right">
          <p class="mb-1">ATED (Annual Tax on Enveloped Dwellings) Calculator</p>
          <p class="mb-0">{{validation.getCurrentDateWithSpecificFormat()}}</p>
        </div> 
      </div>
      <div class="row mt-3 plr-1"  id="secondMain">
        <div class="mapcontainer">
            <app-googlemap [MapClassLoad]="MapLoad" [latitude]="lat" [longitude]="long"></app-googlemap>
        </div>
      </div>
       <div class="row  mt-3 plr-15"  id="thirdMain">
        <div class="col-md-2 col-6 p-back pl17">
            <a [routerLink]="['/ated/step1']" class="backlink">Back</a>
        </div>
        <div class="col-md-10 col-6 p-rec pr13">
        </div>
      </div> 
      <div class="row mt-3 plr-15">
        <div class="col-md-5 pl0">
          <h5 style="padding-top:15px;">
            <b class="questyle">
              Property value?
            </b>
          </h5>
        </div>
        <div class="col-md-7 pr0">
            <select id="PurchaseType" [(ngModel)]="PropertyValue">
                <option value="">Select</option>
                <option *ngFor="let data of propertydropdown" value="{{data?.Id}}">{{data?.Value}}</option>
              </select> 
        </div>
      </div>
     
     
    <div class="row mt-3 plr-15">
        <div class="col-md-12 pr0 mobile-center" style="text-align: right;" *ngIf="PropertyValue!=''">
         <button class="btn btn-defaultNext" type="button" (click)="next()">Next</button>
       </div>
     </div>
    </div>